import {Inject, LOCALE_ID, NgModule, Pipe, PipeTransform} from '@angular/core';
import {MomentAdapter, MomentType} from "../../../shared/utils/moment.utils";

@Pipe({ name: 'moment' })
export class MomentPipe implements PipeTransform {
    private _locale;
    constructor(@Inject(LOCALE_ID) locale) {
        this._locale = locale;
    }

    transform(value: MomentType, format: string): any {
        return MomentAdapter.of(value, this._locale).format(format);
    }
}

@NgModule({
    declarations: [
        MomentPipe,
    ],
    exports: [
        MomentPipe
    ]
})
export class MomentPipeModule{}